// extracted by mini-css-extract-plugin
module.exports = {"gray":"GrayButton_gray___7e9G"};